import { EMPTY, of } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';

export function productHuntAgent(agentApi, msg) {
    return of(undefined).pipe(
        switchMap(() => agentApi.findLastMessageForRole('product-hunt-criteria')),
        switchMap(productHuntCriteria => {
            if (productHuntCriteria) {
                return continueProductHunt(agentApi, productHuntCriteria);
            } else {
                return startProductHunt(agentApi);
            }
        }),
    );
}

let productHuntCriteriaFormat = {
    type: 'object',
    properties: {
        productName: {
            type: 'string',
            minLength: 3,
            maxLength: 128,
        },
        acceptanceCriteria: {
            type: 'array',
            items: {
                type: 'string',
                minLength: 5,
                maxLength: 128,
            },
            maxItems: 32,
        },
    },
    required: [
        'productName',
        'acceptanceCriteria',
    ],
};

function startProductHunt(agentApi) {
    return of(undefined).pipe(
        switchMap(() => agentApi.answerJson('start-product-hunt', {}, productHuntCriteriaFormat)),
        tap(productHuntCriteria => agentApi.appendChatMessage({
            role: 'product-hunt-criteria',
            content: productHuntCriteria,
        })),
        switchMap(() => searchForProducts(agentApi)),
    );
}

function continueProductHunt(agentApi, productHuntCriteria) {
    return of(undefined).pipe(
        switchMap(() => agentApi.answerJson('update-product-hunt', {
            currentProductHuntCriteria: JSON.stringify(productHuntCriteria.content, null, 2),
        }, productHuntCriteriaFormat)),
        tap(productHuntCriteria => agentApi.appendChatMessage({
            role: 'product-hunt-criteria',
            content: productHuntCriteria,
        })),
        switchMap(() => searchForProducts(agentApi)),
    );
}

function searchForProducts(agentApi) {
    // TODO
    return EMPTY;
}
